import { OpenReportAction, OpenReportTypes } from '../../types';
import { Reducer } from 'redux';

export type ChangePasswordState = typeof changePasswordState;

export const changePasswordState = {
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};

const changePasswordReducer: Reducer<ChangePasswordState, OpenReportAction> = (
  state: ChangePasswordState = changePasswordState,
  action: OpenReportAction,
): ChangePasswordState => {
  switch (action.type) {
    case OpenReportTypes.RESET:
      return changePasswordState;
    case OpenReportTypes.SET_CURRENT_PASSWORD:
      const currentPassword = action.payload.currentTarget.value;
      return {
        ...state,
        currentPassword,
      };
    case OpenReportTypes.SET_NEW_PASSWORD:
      const newPassword = action.payload.currentTarget.value;
      return {
        ...state,
        newPassword,
      };
    case OpenReportTypes.SET_CONFIRM_NEW_PASSWORD:
      const confirmNewPassword = action.payload.currentTarget.value;
      return {
        ...state,
        confirmNewPassword,
      };
    case OpenReportTypes.ON_CHANGE_PASSWORD:
      return {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      };
    default:
      return state;
  }
};

export default changePasswordReducer;
